<template>
  <div id="app">
    <!-- <Digital msg="W                     elcome to Your Vue.js App"/> -->
    <router-view></router-view>
    <!-- <Login></Login> -->
  </div>
</template>

<script>
// import Login from './components/Login.vue'

export default {
  name: 'App',
  // components: {
  //   Login
  // }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
